<script lang="ts">
    
    import type { Question } from "../../Model/Question";
    import QuestionHeader from "./QuestionHeader.svelte";

    export let question: Question;
    export let isSaving = false;
    export let isAnswered = false;

    let stateClass = 'is-pending';
    
    $: updateClass(isSaving, isAnswered);

    function updateClass(isSaving: boolean, isAnswered: boolean): void {
        const classesArray: string[] = [];

        if (question?.forced) {
            classesArray.push('is-required');
        }

        if (isSaving) {
            classesArray.push('is-saving');
        } else if (isAnswered) {
            classesArray.push('is-answered');
        } else {
            classesArray.push('is-pending');
        }

        stateClass = classesArray.join(' ');
    }

</script>

<style lang="scss">

    .question-box {
        position: relative;
        margin-top: 1.5rem;
        margin-left: -0.2rem;
        padding-left: 1rem;

        &:first-child {
            margin-top: 0;
        }

        &::before {
            content: '';
            display: block;
            position: absolute;
            top: 0;
            left: 0;
            width: 4px;
            height: 100%;
        }

    }

    :global(.question-box) {

        &.is-saving::before {
            background-color: orange;
        }

        &.is-answered::before {
            background-color: green;
        }

        &.is-pending::before {
            background-color: #ddd;
        }

        &.is-required::before {
            background-color: #aaa;
        }

    }

</style>

<div class="question-box {stateClass}">
    <QuestionHeader {question} />
    <slot />
</div>
